(ns rlws.iot-cloud.frontend.data)

(def asset-states
  {:disconnected {:icon "fa-ban"}
   :cell-connection {:image-path "/img/LC_NoConnection.svg"}
   :error {:image-path "/img/LC_iQube_Alert.svg"}
   :warning {:image-path "/img/LowLevel_Warning.svg"}
   :unknown {:image-path "/img/LC_iQube_Alert.svg"}
   :ok {:image-path "/img/LC_OK.svg"}})

(def diagnostics
  {:dia-power-supply
   {:title "Power Supply"
    :state :error
    :description "The power supply diagnostic flag is set when any CPU board in the system has a power supply fault (input voltage less than 6 VDC or greater than 12 VDC)."}

   :dia-secondary-communication
   {:title "Secondary Communication"
    :state :error
    :description "The secondary communication diagnostic flag is set when any configured secondary CPU board loses communication with the primary CPU board."}

   :dia-excitation-voltage
   {:title "Excitation Voltage"
    :state :error
    :description "The excitation diagnostic flag is set when any CPU board in the system has an excitation voltage fault (excitation voltage below 4.9 VDC)."}

   :dia-cell-connection
   {:title "Cell Connection"
    :state :cell-connection
    :description "The cell connection diagnostic flag is set when one or more load cell wires is disconnected."}

   :dia-cell-overload
   {:title "Cell Overload"
    :state :error
    :description "The overloaded cell diagnostic flag is set when the cell output exceeds a specified percentage of full scale cell output set for the scale."}

   :dia-cell-underload
   {:title "Cell Underload"
    :state :error
    :description "The underloaded cell diagnostic flag is set when the cell output falls below the percentage of full scale cell output set for the
scale."}

   :dia-zero-reference
   {:title "Zero Reference"
    :state :error
    :description "The zero reference diagnostic flag is set when the output of any cell in a stable scale falls outside the zero reference range configured for the scale."}

   :dia-cell-drift
   {:title "Cell Drift"
    :state :error
    :description "The drift diagnostic is used principally for tank and hopper scales that never reach zero."}

   :dia-peak-to-peak-noise
   {:title "Cell Noise"
    :state :error
    :description "The noise diagnostic flag is set when a single cell experiences noise greater than the configured noise threshold."}

   :dia-unbalanced-load
   {:title "Unbalanced Load"
    :state :error
    :description "The unbalanced load diagnostic flag is set when the scale load is not evenly distributed between the load cells. The error can be caused by unbalanced loading of the scale or by non-linear weight distribution caused by scale binding."}

   :emulation
   {:title "Emulation"
    :state :warning
    :description "One of the cells on this scale is being emulated"}

   :gateway-disconnected
   {:title "Gateway Disconnected"
    :state :error
    :description "The gateway device is disconnected"}

   :junction-box-disconnected
   {:title "Junction Box Disconnected"
    :state :error
    :description "The junction box is disconnected"}})
